<div class="overlayDiv">
	<p>
		{{ todayDate | date : 'medium'}}<mat-icon (click)="refresh()">refresh</mat-icon>
	</p>
</div>
<div class="center">
	<strong>Underwriting Queue</strong>
	&nbsp;
	[{{countBudgetAssessment + countFileReview + countUW + countNeedsCoApp + countAOB + countRapidUW + countCoAppObtained + countCAPendingVOE}}]
	&nbsp;
	{{totalBudgetAssessment + totalFileReview + totalUW + totalNeedsCoApp + totalAOB + totalRapidUW + totalCoAppObtained + totalCAPendingVOE | currency}}
</div>
<div>
	<ul class="tabs" role="tablist">
		<!-- <li>
			<input type="radio" name="tabs" id="tab1" checked />
				<label for="tab1" role="tab" aria-selected="true" aria-controls="panel1" tabindex="0">Ready for Loan Interview<br />
					<span class="totalRowPipeline">[{{ countReadyForLoanInterview }}] {{ totalReadyForLoanInterview | currency }}</span>
				</label>
				<div id="tab-content1" class="tab-content" role="tabpanel" aria-labelledby="description"
					aria-hidden="false">
					<app-ready-for-loan-interview
					(sendReadyForLoanInterview)="receiveDataFromReadyForLoanInterview($event)"
					[callCancelled]="callCancelled">
				</app-ready-for-loan-interview>
				</div>
		</li> -->
		<li>
			<input type="radio" name="tabs" id="tab2" checked/>
			<label for="tab2" role="tab" aria-selected="true" aria-controls="panel2" tabindex="1">Budget Assessment<br />
				<span class="totalRowPipeline">[{{ countBudgetAssessment }}] {{ totalBudgetAssessment | currency }}</span>
			</label>
			<div id="tab-content2" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-budget-assessment (sendBudgetAssessment)="receiveDataFromBudgetAssessment($event)"></app-budget-assessment>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab3" />
			<label for="tab3" role="tab" aria-selected="true" aria-controls="panel3" tabindex="2">File Review<br />
				<span class="totalRowPipeline">[{{ countFileReview }}] {{ totalFileReview | currency }}</span>
			</label>
			<div id="tab-content3" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-file-review (sendFileReview)="receiveDataFromFileReview($event)"></app-file-review>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab4" />
			<label for="tab4" role="tab" aria-selected="true" aria-controls="panel4" tabindex="3">Scheduled Loan Interviews<br />
				<span class="totalRowPipeline">[{{ countScheduledInterview }}] </span>
			</label>
			<div id="tab-content4" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-scheduled-loan-interviews
				(updateCallCount)="receiveDataScheduledInterview($event)"
                [(currentUser)]="currentUser"/>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab5" />
			<label for="tab5" role="tab" aria-selected="true" aria-controls="panel5" tabindex="4">Underwriting Checklist<br />
				<span class="totalRowPipeline">[{{ countUW }}] {{ totalUW | currency }}</span>
			</label>
			<div id="tab-content5" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-underwriting-checklist (sendUW)="receiveDataFromUW($event)"></app-underwriting-checklist>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab6" />
			<label for="tab6" role="tab" aria-selected="true" aria-controls="panel6" tabindex="5">Rapid - Underwriting<br />
				<span class="totalRowPipeline">[{{ countRapidUW }}] {{ totalRapidUW | currency }}</span>
			</label>
			<div id="tab-content6" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-rapid-underwriting (sendRapidUW)="receiveDataFromRapidUW($event)"></app-rapid-underwriting>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab7" />
			<label for="tab7" role="tab" aria-selected="true" aria-controls="panel7" tabindex="6">Needs Coapp<br />
				<span class="totalRowPipeline">[{{ countNeedsCoApp }}] {{ totalNeedsCoApp | currency }}</span>
			</label>
			<div id="tab-content7" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-needs-copapp (sendNeedsCoApp)="receiveDataFromNeedsCoAp($event)"></app-needs-copapp>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab8" />
			<label for="tab8" role="tab" aria-selected="true" aria-controls="panel8" tabindex="7">AOB<br />
				<span class="totalRowPipeline">[{{ countAOB }}] {{ totalAOB | currency }}</span>
			</label>
			<div id="tab-content8" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-aob (sendAOB)="receiveDataFromAOB($event)"></app-aob>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab9" />
			<label for="tab9" role="tab" aria-selected="true" aria-controls="panel9" tabindex="9">Co-App Obtained<br />
				<span class="totalRowPipeline">[{{ countCoAppObtained }}] {{ totalCoAppObtained | currency }}</span>
			</label>
			<div id="tab-content8" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-coapp-obtained (sendCoAppObtained)="receiveDataFromCoAppObtained($event)"></app-coapp-obtained>
			</div>
		</li>
		<li>
			<input type="radio" name="tabs" id="tab10" />
			<label for="tab10" role="tab" aria-selected="true" aria-controls="panel10" tabindex="10">Conditionally Approved Pending VOE<br />
				<span class="totalRowPipeline">[{{ countCAPendingVOE }}] {{ totalCAPendingVOE | currency }}</span>
			</label>
			<div id="tab-content10" class="tab-content" role="tabpanel" aria-labelledby="description"
				aria-hidden="false">
				<app-ca-pending-voe (sendCAPendingVOE)="receiveDataFromCAPendingVOE($event)"></app-ca-pending-voe>
			</div>
		</li>
		
	</ul>
</div>
